export const LeadPoolTeampermissions = {
  LeadPoolTeampermissions: {
    permissionsId: "3deb3121-86c2-4bb5-5dc9-08dc7403ebc2",
    permissionsName: "Leads Pool",
    description: null,
    componentsId: null,
    components: null,
  },
};
